import React, { Component } from 'react';

import Input from '../../components/Form/Input/Input';
import Button from '../../components/Button/Button';
import { required, length, email } from '../../util/validators';
import Auth from './Auth';

class Login extends Component {
  state = {
    loginForm: {
      email: {
        value: '',
        valid: false,
        touched: false,
        validators: [required, email]
      },
      password: {
        value: '',
        valid: false,
        touched: false,
        validators: [required, length({ min: 5 })]
      },
      formIsValid: false
    }
  };

  inputChangeHandler = (input, value) => {
    this.setState(prevState => {
      let isValid = true;
      for (const validator of prevState.loginForm[input].validators) {
        isValid = isValid && validator(value);
      }
      const updatedForm = {
        ...prevState.loginForm,
        [input]: {
          ...prevState.loginForm[input],
          valid: isValid,
          value: value
        }
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }
      return {
        loginForm: updatedForm,
        formIsValid: formIsValid
      };
    });
  };

  inputBlurHandler = input => {
    this.setState(prevState => {
      return {
        loginForm: {
          ...prevState.loginForm,
          [input]: {
            ...prevState.loginForm[input],
            touched: true
          }
        }
      };
    });
  };

  render() {
    return (
      <Auth>
        <form
          onSubmit={(e) =>
            this.props.onLogin(e, {
              email: this.state.loginForm.email.value,
              password: this.state.loginForm.password.value,
            })
          }
        >
          <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--negative-gap-attr">
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
              <Input
                id="email"
                label="ایمیل"
                type="email"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "email")}
                value={this.state.loginForm["email"].value}
                valid={this.state.loginForm["email"].valid}
                touched={this.state.loginForm["email"].touched}
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
              <Input
                id="password"
                label="رمز عبور"
                type="password"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "password")}
                value={this.state.loginForm["password"].value}
                valid={this.state.loginForm["password"].valid}
                touched={this.state.loginForm["password"].touched}
              />
            </div>
          </div>
          <Button
            design="next"
            mode=""
            type="submit"
            loading={this.props.loading}
          >
            ورود
          </Button>
        </form>
      </Auth>
    );
  }
}

export default Login;
